<p>lookup-master-add works!</p>
